import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["results", "ResultComponent", "trackInteraction", "trackPageview"];
import UICardGrid from 'UIComponents/card/UICardGrid';
import { useResponsiveProps } from 'ecosystem-marketplace-core/hooks/useResponsiveProps';
import StorefrontSection from '../StorefrontSection';
import { useOfferingType } from '../../../context/OfferingTypeContext';
import { jsx as _jsx } from "react/jsx-runtime";
const StorefrontResultsSection = _ref => {
  let {
      results,
      ResultComponent,
      trackInteraction,
      trackPageview
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const offeringType = useOfferingType();
  const responsiveProps = useResponsiveProps({
    columns: {
      xs: 1,
      sm: 2,
      md: 3
    }
  });
  return /*#__PURE__*/_jsx(StorefrontSection, Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(UICardGrid, Object.assign({}, responsiveProps, {
      children: results.map((result, index) => /*#__PURE__*/_jsx(ResultComponent, {
        index: index,
        offeringType: offeringType,
        result: result,
        resultsLength: results.length,
        trackInteraction: trackInteraction,
        trackPageview: trackPageview
      }, `result-${index}`))
    }))
  }));
};
export default StorefrontResultsSection;